import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import zhHans from 'vuetify/es5/locale/zh-Hans';

Vuetify.config.silent = true;
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#333',
        secondary: '#666',
        accent: '#3f51b5',
        error: '#f51414',
        warning: '#ff9a00',
        info: '#999',
        success: '#43A047',
      },
    },
  },
  lang: {
    locales: { zhHans },
    current: 'zh-Hans',
  },
});
